module.exports = __webpack_public_path__ + "img/logo_f.79d92bd8.png";